<template src="./index.html"></template>
<script>
	import VersionManagement from "./VersionManagement/index.vue";
	import {
		templateExquery,
		templateExadd,
		getShuizList,
		queryCompanySz,
		companysPage,
		getTemplate,
		templateExdelete
	} from '../../../../api/bbmb.js'
	import {getdata} from "./data.js";
	import config from '../../../../../configHttp.js'
	export default {
		name: "bbmb",
		components: {
			VersionManagement,
		},
		data: function() {
			return {
				/* 报表模板查询 */
				searchdata: getdata().searchdata, 
				searchlist: getdata().searchlist,
				outlist: [],
				headData: getdata().headData,
				pagination: getdata().pagination,
				tableData: [],
				shaidiag: false,
				searchdiag: false,
				/* 公司列表查询 */
				companydiag: false,
				headDatachoose: getdata().headDatachoose,
				tableDatachoose: [],
				queryWord: "",
				paginationcompany: {},
				// 表单操作
				szoptions: [],
				bboptions: [],
				mbdiag: false,
				ruleForm: {
					templateName: "",
					shuizId: "",
					shuibId: "",
					versionShuom: "",
					isDefault: "",
				},
				headDatacompany: getdata().headDatacompany,
				tableDatacompany: [],
				rules: {
					templateName: [{
						required: true,
						trigger: 'blur',
						message: '模板名称不能为空',
					}],
					shuizId: [{
						required: true,
						trigger: 'change',
						message: '税种不能为空',
					}],
					shuibId: [{
						required: true,
						trigger: 'change',
						message: '报表不能为空',
					}],
					versionShuom: [{
						required: true,
						trigger: 'blur',
						message: '说明不能为空',
					}],
					isDefault: [{
						trigger: 'blur',
						required: true,
						message: '是否默认不能为空',
					}]
				},
				showVersion: false,
				mbtitle: "新增模板",
				tablekey: 0,
				overlength: 0,
				showbox:false,
			};
		},
		created() {
			this.templateExquery()
		},
		mounted() {
		},
		methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
			showback(e){
				this.showbox = e
			},
			//导出列表
			fordaochu(){
				const selectval = this.$refs.tablebox.getSelectionval()
				
				let params = {
					downUrl: config.baseURL + "templateEx/export",
					typeObj: {
						toForm: false,
						fileType: "xlsx",
						failUrl:this.$winURl
					},
					params: {
						"ids": selectval.map(item => item.id),
					},
				};
				this.$downloadcommon(params);
			},
			//报表模板查询
			templateExquery() {
				let params = JSON.parse(JSON.stringify(this.searchdata))
				params.current = this.pagination.pageNum
				params.size = this.pagination.pageSize
				templateExquery(params).then(res => {
					this.getShuizList()
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records
				})
			},
			sizechange(e) {
				this.pagination.pageSize = e
				this.templateExquery()
			},
			currentChange(e) {
				this.pagination.pageNum = e
				this.templateExquery()
			},
			submitSearch() {
				this.pagination.pageNum = 1
				this.pagination.paginationkey++
				this.templateExquery()
			},
			///新增模板
			foraddmb() {
				Object.keys(this.ruleForm).map(key => (this.ruleForm[key] = ''));
				this.tableDatacompany = []
				this.queryCompanySz()
				this.rules={
					templateName: [{
						required: true,
						trigger: 'blur',
						message: '模板名称不能为空',
					}],
					shuizId: [{
						required: true,
						trigger: 'change',
						message: '税种不能为空',
					}],
					shuibId: [{
						required: true,
						trigger: 'change',
						message: '报表不能为空',
					}],
					versionShuom: [{
						required: true,
						trigger: 'blur',
						message: '说明不能为空',
					}],
					isDefault: [{
						trigger: 'change',
						required: true,
						message: '是否默认不能为空',
					}]
				}
				this.mbtitle = "新增模板";
			},
			queryCompanySz() {
				queryCompanySz().then(res => {
					if(res.data.code==1){
						this.szoptions = res.data.data
						if(this.$emptyandnull(this.ruleForm.shuizId)){
							this.ruleForm.shuizId = this.szoptions[0].shuizId
						}
						if(this.szoptions&&this.szoptions.length>0){
							this.shuizIdchange(this.ruleForm.shuizId)
						}
					}else{
						this.$message.error(res.data.msg)
					}
					
				})
			},
			shuizIdchange(e) {
				 var newarr=this.szoptions.length>0?this.szoptions.filter(item => item.shuizId == e)[0].children.map(item=>{
					 return item
				 }):[]
				 this.bboptions=newarr==[]?'':JSON.parse(JSON.stringify(newarr))
				if(this.$notemptyandnull(this.bboptions)){
					// this.ruleForm.shuibId = this.bboptions[0].shuibId
				}
				this.mbdiag = true;
				this.$nextTick(() => {
					this.$refs['ruleForm'].clearValidate();
				})
			},
			getShuizList() {
				getShuizList().then(res => {
					this.searchlist.forEach(item => {
						if (item.prop == "shuizId") {
							item.selectval = res.data.data.map(item => {
								return {
									label: item.shuizmc,
									value: item.id
								}
							})
						}
					})
					let newarr = JSON.parse(JSON.stringify(this.searchlist))
					this.searchlist = newarr
				})
			},
			foraddcompany() {
				let params = {}
				params.current = this.paginationcompany.pageNum
				params.size = this.paginationcompany.pageSize
				params.queryWord = this.queryWord
				companysPage(this.params).then(res => {
					this.paginationcompany.total = res.data.data.total;
					this.tableDatachoose = res.data.data.records
					this.companydiag = true
				})
			},
			fordeletecompany() {
				const selectval = this.$refs.tableboxcompamy.getSelectionval()
				this.tableDatacompany = this.tableDatacompany.filter(item => !(selectval.map(gtem => gtem.companyNo).includes(item
					.companyNo)))
			},
			fordeletemb() {
				const selectval = this.$refs.tablebox.getSelectionval()
				if (!(selectval.length > 0)) {
					this.$message.error("请选择要删除的数据")
					return false
				}
				this.$confirm('确定删除?', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					templateExdelete(selectval.map(item=>item.id)).then(res=>{
						if (res.data.code == "1") {
							this.$message.success(res.data.msg)
							this.templateExquery()
						} else {
							this.$message.error(res.data.msg)
						}
					})
				})
			},
			//提交表单
			forsurecompany() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						let params = JSON.parse(JSON.stringify(this.ruleForm))
						params.compangNos = this.tableDatacompany.map(item => item.companyNo)
						templateExadd(params).then(res => {
							if (res.data.code == "1") {
								this.mbdiag = false
								this.$message.success(res.data.msg)
								this.templateExquery()
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				});

			},
			inputcompanysPage() {
				this.queryWord = ""
				this.paginationcompany.pageNum = 1
				this.paginationcompany.paginationkey++
				this.foraddcompany()
			},
			sizechangechoose(e) {
				this.paginationcompany.pageSize = e
				this.foraddcompany()
			},
			currentChangechoose(e) {
				this.paginationcompany.pageNum = e
				this.foraddcompany()
			},
			forchoosecompany() {
				const selectval = this.$refs.tableboxchoose.getSelectionval()
				selectval.forEach(item => {
					if (!(this.tableDatacompany&&this.tableDatacompany.map(gtem => gtem.companyNo).includes(item.companyNo))) {
						this.tableDatacompany.push(item)
					}
				})
				this.companydiag = false
			},
			forseexq(taxval){
				getTemplate({
					id: taxval.id
				}).then(res => {
					this.ruleForm = JSON.parse(JSON.stringify(res.data.data)) 
					this.ruleForm.shuibId=taxval.shuibId
					this.ruleForm.sbbm=taxval.sbbm
					this.showVersion=true
				})
			},
			//模板编辑
			forseejcxinxi(taxval) {
				getTemplate({
					id: taxval.id
				}).then(res => {
					this.ruleForm = JSON.parse(JSON.stringify(res.data.data)) 
					delete this.ruleForm.companyInfos
					this.rules = {}
					this.tableDatacompany = res.data.data.companyInfos||[]
					this.queryCompanySz()
					this.mbtitle = "模板编辑";
					this.mbdiag = true;
					this.$nextTick(() => {
						this.$refs['ruleForm'].clearValidate();
					})
				})
			},
			forback() {
				this.showVersion = false;
				this.templateExquery()
			},
			forRefresh() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
			},
			forUpdateSearch() {
				this.searchdiag = true;
			},
			closeSearch() {
				this.searchdiag = false;
			},
			saveChange(e) {
				this.searchdiag = false;
			},
			confirmfilter(e) {
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
			},
			closeshaidiag() {
				this.shaidiag = false;
			},
		},
	};
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>
